import './App.scss';
import React, { useState } from 'react';
import { MenuItem, FormControl, Select } from "@material-ui/core";
import { Country } from "./List"
import GetData from "./GetData"




function App() {
  const [Select_Country, setSelect_Country] = useState("United States")

  const onCountryChange = async (event) => {
    setSelect_Country(event.target.value)
  };



  return (
    <div className="App">
      <div className="title_block">
        <h1>World Statistics</h1>
        {/* <p>Select Your country > </p> */}
      </div>
      <div className="app__dropdown" >
        <p>Select Your country >> </p>
        <FormControl>
          <Select variant="outlined" value={Select_Country} onChange={onCountryChange} style={{ color: 'white' }}>
            {/* <MenuItem value="United States">United States</MenuItem> */}
            {Country.map((country) => (
              <MenuItem value={country}>{country}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className="grid">
        <GetData
          Select_Country={Select_Country}
          Indicator={"SP.POP.TOTL"}
          Data_Label="Population"
          Order="descending"
          Digit="-8"
          Scale="M"
        />
        <GetData
          Select_Country={Select_Country}
          Indicator={"NY.GDP.MKTP.CD"}
          Data_Label="GDP (current US$)"
          Order="descending"
          Digit="-16"
          Scale="T"
        />

        <GetData
          Select_Country={Select_Country}
          Indicator={"NY.GDP.MKTP.KD.ZG"}
          Data_Label="GDP growth (annual %)"
          Order="descending"
          Digit="0"
          Float="0"
        />

        <GetData
          Select_Country={Select_Country}
          Indicator={"GC.TAX.TOTL.GD.ZS"}
          Data_Label="Tax revenue (% of GDP)"
          Order="descending"
          Digit="0"
          Float="0"
          height="2700"
        />

        <GetData
          Select_Country={Select_Country}
          Indicator={"NY.GDP.PCAP.CD"}
          Data_Label="GDP per capita (current US$)"
          Order="descending"
          Digit="-4"
          Scale="K"
        />

        <GetData
          Select_Country={Select_Country}
          Indicator={"TX.VAL.MRCH.CD.WT"}
          Data_Label="Merchandise exports (current US$)"
          Order="descending"
          Digit="-12"
          Scale="B"
        />

        <GetData
          Select_Country={Select_Country}
          Indicator={"TM.VAL.MRCH.CD.WT"}
          Data_Label="Merchandise imports (current US$)"
          Order="descending"
          Digit="-12"
          Scale="B"
        />

        <GetData
          Select_Country={Select_Country}
          Indicator={"IP.PAT.RESD"}
          Data_Label="Patent applications, residents"
          Order="descending"
          height="2700"
          Digit="-4"
          Scale="K"
        />

        <GetData
          Select_Country={Select_Country}
          Indicator={"GB.XPD.RSDV.GD.ZS"}
          Data_Label="Research and development expenditure (% of GDP)"
          Order="descending"
          height="2500"
          Digit="0"
        />

        <GetData
          Select_Country={Select_Country}
          Indicator={"SG.GEN.PARL.ZS"}
          Data_Label="Proportion of seats held by women in national parliaments (%)"
          Order="descending"
          Digit="0"
          Float="0"
        />


        <GetData
          Select_Country={Select_Country}
          Indicator={"IC.BUS.EASE.XQ"}
          Data_Label="Ease of doing business index (1=most business-friendly regulations)"
          Order="ascending"
          Digit="0"
        />
      </div>
      <hr />
      <span className="footer">DataSource: <a href="https://www.worldbank.org/">WorldBank</a> Copyright © F_Tokumitsu</span>
    </div >
  );
}

export default App;